import { render, staticRenderFns } from "./OrdersReport.vue?vue&type=template&id=5f90f23d&scoped=true"
import script from "./OrdersReport.vue?vue&type=script&lang=js"
export * from "./OrdersReport.vue?vue&type=script&lang=js"
import style0 from "./OrdersReport.vue?vue&type=style&index=0&id=5f90f23d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f90f23d",
  null
  
)

export default component.exports